// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__yl3k1","grid":"Footer_grid__8O8gL","copyright":"Footer_copyright__g3z6w","social_media":"Footer_social_media__4quOG"};